(() => {
  'use strict';
  if (customElements.get('mavelle-color-preview')) return;
  class ColorPreview extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      try { this.colors = JSON.parse(this.querySelector('[data-color-data]').textContent); }
      catch { return; }
      if (!Array.isArray(this.colors) || !this.colors.length) return;
      this.units = this.dataset.optionName === 'Design' ? 'designs' : 'colors';
      this.singular = this.dataset.optionName === 'Design' ? 'design' : 'color';
      this.dialog = this.querySelector('dialog');
      this.grid = this.querySelector('[data-grid]');
      this.search = this.querySelector('[data-search]');
      this.addEventListener('click', event => this.onClick(event), options);
      this.search.addEventListener('input', () => this.filter(), options);
      this.dialog.addEventListener('close', () => this.returnFocus?.focus({ preventScroll: true }), options);
      document.addEventListener('change', event => {
        if (event.target.closest?.('variant-picker') === this.pickerSelect()?.closest('variant-picker')) this.sync();
      }, options);
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) === this.dataset.productId) this.sync();
      }, options);
      if (!this.pickerSelect()) return;
      this.sync();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
    pickerSelect() {
      const scope = this.closest('.shopify-section, featured-product-information, quick-add-dialog') || this.parentElement;
      const picker = [...scope.querySelectorAll('variant-picker')].find(node => node.dataset.productId === this.dataset.productId);
      return [...(picker?.querySelectorAll('select') || [])].find(select => select.name === `options[${this.dataset.optionName || 'Color'}]`) || null;
    }
    sync() {
      const selected = this.pickerSelect()?.value;
      this.current = this.colors.find(color => color.option === selected);
      if (!this.current) { this.hidden = true; return; }
      this.querySelector('[data-color-name]').textContent = this.current.name;
      const image = this.querySelector('[data-preview-image]');
      const button = this.querySelector('[data-action="zoom"]');
      if (image && this.current.preview) {
        if (image.getAttribute('src') !== this.current.preview) image.setAttribute('src', this.current.preview);
        image.alt = this.current.name;
        button.setAttribute('aria-label', `Enlarge ${this.current.name} image`);
        button.hidden = false;
      } else button.hidden = true;
      this.hidden = false;
      this.grid?.querySelectorAll('[data-color-index]').forEach(button => {
        button.setAttribute('aria-pressed', String(this.colors[Number(button.dataset.colorIndex)]?.id === this.current.id));
      });
    }
    buildGrid() {
      this.grid.replaceChildren();
      this.colors.forEach((color, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'mcp-choice';
        button.dataset.colorIndex = String(index); button.disabled = !color.available;
        button.setAttribute('aria-label', color.name + (color.available ? '' : ' — Sold out'));
        button.setAttribute('aria-pressed', String(color.id === this.current?.id));
        if (color.thumb) {
          const image = document.createElement('img');
          image.src = color.thumb; image.alt = ''; image.loading = 'lazy'; image.width = 160; image.height = 160;
          button.appendChild(image);
        }
        const label = document.createElement('span');label.textContent = color.name + (color.available ? '' : ' — Sold out');
        button.appendChild(label);this.grid.appendChild(button);
      });
    }
    filter() {
      const term = this.search.value.trim().toLowerCase();let count = 0;
      this.grid.querySelectorAll('[data-color-index]').forEach(button => {
        const match = this.colors[Number(button.dataset.colorIndex)].name.toLowerCase().includes(term);
        button.hidden = !match; if (match) count++;
      });
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.querySelector('[data-results]').textContent = `${count} of ${this.colors.length} ${this.units}`;
    }
    open(mode, trigger) {
      this.returnFocus = trigger;
      const zoom = mode === 'zoom';
      this.querySelector('[data-browser]').hidden = zoom;
      this.querySelector('[data-zoom]').hidden = !zoom;
      this.querySelector('[data-dialog-title]').textContent = zoom ? `Selected ${this.singular}` : `Choose your ${this.singular}`;
      if (zoom) {
        if (!this.current?.zoom) return;
        const image = this.querySelector('[data-zoom-image]');image.src = this.current.zoom;image.alt = this.current.name;
        this.querySelector('[data-zoom-name]').textContent = this.current.name;
      } else { this.buildGrid();this.search.value = '';this.filter(); }
      if (!this.dialog.open) this.dialog.showModal();
      if (!zoom) this.search.focus({ preventScroll: true });
    }
    onClick(event) {
      const target = event.target.closest('button');if (!target || !this.contains(target)) return;
      const action = target.dataset.action;
      if (action === 'close') this.dialog.close();
      else if (action === 'browse' || action === 'zoom') this.open(action, target);
      else if (target.dataset.colorIndex !== undefined) {
        const color = this.colors[Number(target.dataset.colorIndex)],select = this.pickerSelect();
        if (!color?.available || !select || ![...select.options].some(option => option.value === color.option)) return;
        if (select.value !== color.option) {
          select.value = color.option;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();this.dialog.close();
      }
    }
  }
  customElements.define('mavelle-color-preview', ColorPreview);
})();

